export default __webpack_public_path__ + "static/media/118-malasya.afe6f673.svg";